export default "__VITE_ASSET__da3f01e8__"